import api from './api';

export const getWalletNonce = ({ address }) => api.post('/wallets/link/nonce', { address });

export const linkWallet = ({ message, signature }) => api.post('/wallets/link', { message, signature });
